var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6663 64V57.3333C56.6663 53.7971 55.2616 50.4057 52.7611 47.9052C50.2606 45.4048 46.8692 44 43.333 44H16.6663C13.1301 44 9.73873 45.4048 7.23825 47.9052C4.73776 50.4057 3.33301 53.7971 3.33301 57.3333V64M43.333 17.3333C43.333 24.6971 37.3635 30.6667 29.9997 30.6667C22.6359 30.6667 16.6663 24.6971 16.6663 17.3333C16.6663 9.96954 22.6359 4 29.9997 4C37.3635 4 43.333 9.96954 43.333 17.3333Z",
    stroke: "#EE4B22",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatarIcon.cf4a660508f191b45b58266c82694c0e.svg";
export { ForwardRef as ReactComponent };